export default __webpack_public_path__ + "static/new-roma-4-dff9af86b9e966650b481f81e935ea83.jpg";